import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getResourceTo } from 'react/utils/utils';


function IntegrationCard({
  id,
  isConfigurable,
  cardName,
  hasError,
  active,
  onClickOnConfig,
  children,
  infoText
}) {
  return (
    <div data-testid={`IntegrationContainer-${id}`} className="IntegrationContainer">
      <div
        data-testid={`IntegrationCard-${id}`}
        className={`IntegrationCard ${hasError && active ? 'ContainerError' : ''}`}
      >
        <div className="CardHeader">
          <div className="CardTitle" title={cardName}>
            {cardName}
          </div>
          <div className="tools">
            {active && isConfigurable && (
              <div
                data-testid={`settings-buttons-${id}`}
                className="IntegrationSettingsButton"
                onClick={onClickOnConfig}
              />
            )}
            {infoText && (
               <div
                data-testid={`info-${id}`}
                className="IntegrationInfo"
                title={getResourceTo(infoText)}
              />
            )}
          </div>
        </div>
        <div className="CardContainer">
          {children}
        </div>
      </div>
    </div>
  );
}

IntegrationCard.propTypes = {
  id: PropTypes.string,
  cardName: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  isConfigurable: PropTypes.bool,
  hasError: PropTypes.bool,
  onClickOnConfig: PropTypes.func,
  children: PropTypes.node.isRequired,
  infoText: PropTypes.string
};

IntegrationCard.defaultProps = {
  id: null,
  hasError: false,
  isConfigurable: false,
  onClickOnConfig: () => null,
  infoText: null
};

export default memo(IntegrationCard);
